export class LeaderboardDialog {
  private readonly dialog: HTMLDialogElement;
  private readonly closeButton: HTMLButtonElement;
  private readonly home: HTMLElement;
  private readonly mount: HTMLElement;
  private opener?: HTMLElement;

  public constructor(
    root: HTMLElement,
    private readonly board: HTMLElement,
  ) {
    this.dialog = requireElement(root, '#leaderboard-dialog', HTMLDialogElement);
    this.closeButton = requireElement(root, '[data-close-leaderboard]', HTMLButtonElement);
    this.home = requireElement(root, '#leaderboard-board-home', HTMLElement);
    this.mount = requireElement(root, '[data-leaderboard-dialog-mount]', HTMLElement);
    this.closeButton.addEventListener('click', this.close);
    this.dialog.addEventListener('cancel', this.handleCancel);
    this.dialog.addEventListener('click', this.handleBackdropClick);
    this.dialog.addEventListener('close', this.handleClose);
  }

  public get isOpen(): boolean {
    return this.dialog.open;
  }

  public open(opener: HTMLElement): boolean {
    if (this.dialog.open) return false;
    this.opener = opener;
    this.mount.append(this.board);
    document.documentElement.classList.add('leaderboard-open');
    document.body.classList.add('leaderboard-open');
    this.dialog.showModal();
    requestAnimationFrame(() => {
      this.board.querySelector<HTMLElement>('#leaderboard-list')?.focus();
    });
    return true;
  }

  public close = (): void => {
    if (this.dialog.open) this.dialog.close();
  };

  public destroy(): void {
    this.close();
    this.closeButton.removeEventListener('click', this.close);
    this.dialog.removeEventListener('cancel', this.handleCancel);
    this.dialog.removeEventListener('click', this.handleBackdropClick);
    this.dialog.removeEventListener('close', this.handleClose);
  }

  private readonly handleCancel = (event: Event): void => {
    event.preventDefault();
    this.close();
  };

  private readonly handleBackdropClick = (event: MouseEvent): void => {
    if (event.target === this.dialog) this.close();
  };

  private readonly handleClose = (): void => {
    document.documentElement.classList.remove('leaderboard-open');
    document.body.classList.remove('leaderboard-open');
    this.home.append(this.board);
    const opener = this.opener;
    this.opener = undefined;
    requestAnimationFrame(() => opener?.focus());
  };
}

const requireElement = <T extends typeof Element>(
  root: HTMLElement,
  selector: string,
  constructor: T,
): InstanceType<T> => {
  const element = root.querySelector(selector);
  if (!(element instanceof constructor)) throw new Error(`Missing dialog element: ${selector}`);
  return element as InstanceType<T>;
};
